class adminCtrl {
    constructor($scope, $state, $rootScope) {
        $scope.toRouterState = function (v) {
            if (v == 0) {
                $state.go('system.syssetting.company.info')
            } else if (v == 1) {
                $state.go('system.syssetting.taxCertificate.list')
            } else if (v == 2) {
                $state.go('system.syssetting.org.list')
            }
            $rootScope.$broadcast('enterSystem')
        }
    }
}
adminCtrl.$inject = ['$scope', '$state', '$rootScope']
export default adminCtrl



// WEBPACK FOOTER //
// ./src/app/main/home/adminCtrl.js